
export const Mixin = {
	methods: {
			handleTopMouseD(parent,tab){
				if(this.getScrollHeight(parent,tab) > $(parent).find('.tab-header').height()){
					$(parent).find('.innerTabs').animate({top:"0"},"slow")
				}
			},
			handleBtmMouseD(parent,tab){
				if(this.getScrollHeight(parent,tab) > $(parent).find('.tab-header').height()){
					$(parent).find('.innerTabs').animate({top: "-"+ this.getScrollDeltaY(parent,tab)+"px"},"slow")
				}
			},
			handleMouseUp(parent){
				$(parent).find('.innerTabs').stop();
			},
			getScrollHeight(parent,tab){
				var labelHeight = 0;
				$(parent).find(tab).each(function(){
					labelHeight += $(this).outerHeight(true)
				});
				return labelHeight;
			},
			getScrollDeltaY(parent,tab){
				return this.getScrollHeight(parent,tab)-$(parent).find('.tab-header').innerHeight()+40;
			}
		 
  		}
}


// WEBPACK FOOTER //
// ./src/components/pages/vehiclemonitor/mixin.js